import { FunctionComponent } from "react";
import { Title } from "@fyrstain/fhir-front-library";
import styles from "./Home.module.css";
import AcesoPage from "src/components/AcesoPage/AcesoPage";
import { useTranslation } from "react-i18next";

const AcesoHome: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <AcesoPage loading={false} needsLogin={false} >
      <div className={styles.mainHomeContainer}>
        <img
          className={styles.homeimageIcon}
          alt={t("a11y.homeIllustration")}
          src="https://fyrstain.com/wp-content/uploads/2022/10/anim_une.svg"
        />
        <Title level={1} prefix="Aceso" content={t("title.patientadministration")} />
      </div>
    </AcesoPage>
  );
};

export default AcesoHome;
